import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OpenUrlService {

  openUrl(url: string) {
    const a = document.createElement('a')
    a.style.position = 'fixed'
    a.style.opacity = '0'
    a.target = '_blank'
    a.href = url
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

}
